import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';

const state = {
    profile: {
        email: null,
        password: null,
        meta_keys: {
            apellido: null,
            celular: null,
            nombre: null,
            ubicacion_id: null,
            ubicacion_name: null,
            profile_pic: null
        },
        tipo_usuario: null
    },
    usuarios: [],
    roles: [],
    informes: {
        reportes: 0,
        inspeccion: 0,
        mercadeo: 0,
        seguimiento: 0,
        retirados: 0,
        usuarios: 0,
        clientes: 0,
        inspecciones: 0
    },
    isEditUser: false,
    usuario: {
        index: null,
        _id: null,
        nombre: null,
        apellido: null,
        celular: null,
        ubicacion_id: null,
        ubicacion_name: null,
        correo_electronico: null,
        password: null,
        tipo_usuario: null,
        id_empresa: null,
        select_empresa: null,
        status: null,

    }
};

const mutations = {
    updateField,
    updateProfile: (state, payload) => {
        state.profile = payload;
    },
    updateUsuarios: (state, payload) => {
        state.usuarios = payload;
    },
    updateRoles: (state, payload) => {
        state.roles = payload;
    },
    updateInformes: (state, payload) => {
        state.informes = payload;
    },
    addUsuario: (state, payload) => {
        state.usuarios.push(payload);
    },
    updateUsuario: (state, payload) => {
        Object.assign(state.usuarios[payload.index], payload);
    },
    addUsuarioModal: (state, payload) => {
        state.isEditUser = false;
        state.usuario.index = null;
        state.usuario._id = null;
        state.usuario.nombre = null;
        state.usuario.apellido = null;
        state.usuario.celular = null;
        state.usuario.ubicacion_id = null;
        state.usuario.ubicacion_name = null;
        state.usuario.correo_electronico = null;
        state.usuario.tipo_usuario = null;
    },
    editUsuario: (state, payload) => { 
        state.isEditUser = true;
        var indexUser = _.findIndex(state.usuarios, {_id: payload });
        state.usuario.index = indexUser;
        let usuarioData = state.usuarios[indexUser];
        state.usuario._id = usuarioData._id;
        state.usuario.nombre = usuarioData.meta_keys.nombre;
        state.usuario.apellido = usuarioData.meta_keys.apellido;
        state.usuario.celular = usuarioData.meta_keys.celular;
        state.usuario.ubicacion_name = usuarioData.meta_keys.ubicacion_name;
        state.usuario.ubicacion_id = usuarioData.meta_keys.ubicacion_id;
        state.usuario.correo_electronico = usuarioData.email;
        state.usuario.status = usuarioData.status;
        state.usuario.tipo_usuario = usuarioData.tipo_usuario;
    },
    updateStatusUsuario: (state, payload) => {
        console.log(">>>>>", payload);
        var usuario = state.usuarios[payload.index];
        usuario.status = payload.status;
        Object.assign(state.usuarios[payload.index], usuario);
    }
};

const getters = {
    getField,
    usuariosActivos: (state) => {
        var filterUsers = _.filter(state.usuarios, usuario => {
            return usuario.status == "activado";
        });
        return filterUsers
    },
    usuariosInactivos: (state) => {
        var filterUsers = _.filter(state.usuarios, usuario => {
            return usuario.status == "desactivado";
        });
        return filterUsers
    }
};

const actions = {
    updateStatus: ({commit}, payload) => {
        return new Promise((resolve, reject) => {
            axios.post("/ajax/update_status_usuario", payload).then((response) => {
                var newUser = {
                    ...response.data.usuario,
                    index: payload.index
                }
                commit('updateStatusUsuario', newUser);
                resolve(true);
            });
        });
    }        
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
